import autocomplete from "../autocomplete";

// Site search: each suggestion links to its own page.
const pagePath = (result) => result.url;
const siteSearch = (q) => `/search.json?q=${q}`;

autocomplete(document.querySelector("#top_search_container"), { url: siteSearch, href: pagePath });

// The home page puts the same search in its hero, where it is the main way in.
const hero = document.querySelector("#hero_search_container");
if (hero) {
  autocomplete(hero, { url: siteSearch, href: pagePath });
}

// Person page: show this person alongside another.
const personWith = document.querySelector("#person_id_auto_container");
if (personWith) {
  autocomplete(personWith, {
    url: (q) => `/people/search.json?q=${q}`,
    href: (person) => `?with=${encodeURIComponent(person.name)}`,
    name: "q",
    placeholder: "Search people",
  });
}

// Admin link forms: picking a suggestion fills the field with its id.
const eventPicker = document.querySelector("#event_link_event2_id_container");
if (eventPicker) {
  autocomplete(eventPicker, {
    url: (q) => `/events/search.json?q=${q}`,
    valueOf: (event) => event.id,
    name: eventPicker.getAttribute("inputname"),
    id: "event_link_event2_id",
    placeholder: "Search events",
  });
}

const personPicker = document.querySelector("#person_link_person_id_container");
if (personPicker) {
  autocomplete(personPicker, {
    url: (q) => `/people/search.json?q=${q}`,
    valueOf: (person) => person.id,
    name: personPicker.getAttribute("inputname"),
    id: "person_link_person_id",
    placeholder: "Search people",
  });
}
